import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { FMSThemeProvider } from "contexts/FMSThemeContext";
import { ThemeProvider } from "@mui/material";
import { ReactQueryConfigProvider } from "react-query";
import { LoggerProvider } from "contexts/LoggerContext";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: [
      "Source Sans Pro",
      "-apple-system",
      "BlinkMacSystemFont",
      "Segoe UI",
      "Roboto",
      "Oxygen",
      "Ubuntu",
      "Cantarell",
      "Fira Sans",
      "Droid Sans",
      "Helvetica Neue",
      "sans-serif",
    ].join(","),
    button: {
      textTransform: "none",
    },
  },
});

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <LoggerProvider>
      <ReactQueryConfigProvider
        config={{ queries: { refetchOnWindowFocus: false } }}
      >
        <ThemeProvider theme={theme}>
          <FMSThemeProvider>
            <App />
          </FMSThemeProvider>
        </ThemeProvider>
      </ReactQueryConfigProvider>
    </LoggerProvider>
  </React.StrictMode>
);
